import styled          from 'styled-components';
import MuiAppBar       from '@mui/material/AppBar';
import { Badge } from '@mui/material';
import Toolbar         from '@mui/material/Toolbar';
import { AppBarProps } from '@shared/components/Layout/components/Header/Header';
import { colorTheme } from '@styles/muiTheme';

export const AppBar = styled(MuiAppBar)<AppBarProps>(
  ({ theme }) => `
    display: flex;
    justify-content: center;
    background: ${theme.palette.common.white};
    color: ${theme.palette.common.black};
    transition: ${theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    })};
  `
);

export const HeaderToolbar = styled(Toolbar)`
  gap: 15px;
  min-height: 55px;
  padding: 0 32px;
`;

export const LogoGroup = styled.div`
  display: flex;
  align-items: center;

  & > svg {
    margin-top: -5px;
  }
`;

export const SearchGroup = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ControlsGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const PhxLogoWrapper = styled.div`
  cursor: pointer;
`;

export const HeaderControlsWrapper = styled.div`
  gap: 20px;
  display: flex;
  position: relative;
`;

export const HeaderNotificationsWrapper = styled.div`
  gap: 10px;
  display: flex;
  align-items: center;
`;

export const HeaderBadge = styled(Badge)`
  && {
    .MuiBadge-standard {
      background-color: #3c8dbc;
      height: 16px;
      min-width: 16px;
      font-size: 10px;
      padding: 0 4px;
      margin: 2px 4px;
      font-weight: 700;
    }
  }
`;

export const UserSelector = styled.div`
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 13px;
  color: ${colorTheme.palette.common.black};
  gap: 10px;
  width:220px;
  white-space:nowrap;
  .MuiInputBase-input {
    width: 200px;
  }
`;